import {Encrypt, Decrypt} from '@/services/Crypt/AES'
    export default function MenuSet()
    {
        
        if(localStorage.getItem('d1')!=null)
        {
            const data:string = Decrypt(localStorage.getItem('d1')?.toString())
            //console.log(data);
            const splitdata = data.split('@')
            //console.log(splitdata)
            return splitdata[0]
        }
        else
        {
            return null
        }
       
    }

    export function EmailGet()
    {
        
        if(localStorage.getItem('d1')!=null)
        {
            const data:string = Decrypt(localStorage.getItem('d1')?.toString())
            //console.log(data);
            //const splitdata = data.split('@')
            //console.log(splitdata)
            return data
        }
        else
        {
            return null
        }
       
    }
